import './App.css';
import Sidebar from './components/Sidebar'
function App() {
  return (
    
      <div className='pb-10 '>
          <Sidebar/>
      </div>

  );
}

export default App;
